export const DEFAULT_BANK_GROUP = "promo";

export const CHANGE_LOCALE = "app/LanguageSelect/CHANGE_LOCALE";
export const DEFAULT_LOCALE = "en";

export const STATIC_IMAGE_ROCKETMAN_REGEXP = new RegExp(/\s*(rocketman)/g);

/**
 * USER
 */

export const USER_LOADING_SHOW = "USER_LOADING_SHOW";
export const USER_LOADING_HIDE = "USER_LOADING_HIDE";

export const USER_SHOW_SUCCESS = "USER_SHOW_SUCCESS";
export const USER_HIDE_SUCCESS = "USER_HIDE_SUCCESS";

export const USER_UPDATE_DATA = "USER_UPDATE_DATA";
export const USER_UPDATE_PASSWORD = "USER_UPDATE_PASSWORD";

export const USER_UPDATE_BALANCE = "USER_UPDATE_BALANCE";

export const HISTORY_GET_SPORT_BETS_HISTORY = "HISTORY_GET_SPORT_BETS_HISTORY";
export const HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS =
  "HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS";
export const HISTORY_GET_SPORT_BETS_HISTORY_FAILURE =
  "HISTORY_GET_SPORT_BETS_HISTORY_FAILURE";

export const USER_CHECK = "USER_CHECK";
export const USER_CHECK_SUCCESS = "USER_CHECK_SUCCESS";
export const USER_CHECK_FAILURE = "USER_CHECK_FAILURE";

export const USER_SIGN_IN = "USER_SIGN_IN";
export const USER_SIGN_IN_SUCCESS = "USER_SIGN_IN_SUCCESS";
export const USER_SIGN_IN_FAILURE = "USER_SIGN_IN_FAILURE";

export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const USER_SIGN_OUT_SUCCESS = "USER_SIGN_OUT_SUCCESS";
export const USER_SIGN_OUT_FAILURE = "USER_SIGN_OUT_FAILURE";

/**
 * LOBBY
 */

export const LOBBY_GET_PARAMS = "LOBBY_GET_PARAMS";
export const LOBBY_GET_PARAMS_SUCCESS = "LOBBY_GET_PARAMS_SUCCESS";
export const LOBBY_GET_PARAMS_FAILURE = "LOBBY_GET_PARAMS_FAILURE";
export const LOBBY_GET_LANGUAGES = "LOBBY_GET_LANGUAGES";
export const LOBBY_GET_LANGUAGES_SUCCESS = "LOBBY_GET_LANGUAGES_SUCCESS";
export const LOBBY_GET_LANGUAGES_FAILURE = "LOBBY_GET_LANGUAGES_FAILURE";
export const TOGGLE_INFO_MODAL = "TOGGLE_INFO_MODAL";
export const TOGGLE_CONTACTS_MODAL = "TOGGLE_CONTACTS_MODAL";
export const TOGGLE_RULES_MODAL = "TOGGLE_RULES_MODAL";
export const TOGGLE_SPORT_BETS_HISTORY_MODAL =
  "TOGGLE_SPORT_BETS_HISTORY_MODAL";

/**
 * VOUCHER
 */

export const VOUCHER_SHOW_LOADING = "VOUCHER_SHOW_LOADING";
export const VOUCHER_HIDE_LOADING = "VOUCHER_HIDE_LOADING";

export const VOUCHER_SHOW_SUCCESS = "VOUCHER_SHOW_SUCCESS";
export const VOUCHER_HIDE_SUCCESS = "VOUCHER_HIDE_SUCCESS";

export const VOUCHER_PAY_OFF = "VOUCHER_PAY_OFF";
export const VOUCHER_PAY_OFF_SUCCESS = "VOUCHER_PAY_OFF_SUCCESS";
export const VOUCHER_PAY_OFF_FAILURE = "VOUCHER_PAY_OFF_FAILURE";

export const VOUCHER_CREATE = "VOUCHER_CREATE";
export const VOUCHER_CREATE_SUCCESS = "VOUCHER_CREATE_SUCCESS";
export const VOUCHER_CREATE_FAILURE = "VOUCHER_CREATE_FAILURE";

/**
 * GAMES
 */
export const GAMES_FETCH = "GAMES_FETCH";
export const GAMES_FETCH_SUCCESS = "GAMES_FETCH_SUCCESS";
export const GAMES_FETCH_FAILURE = "GAMES_FETCH_FAILURE";
export const UPDATE_FAVORITE_GAME = "UPDATE_FAVORITE_GAME";
export const GAME_RUN = "GAME_RUN";
export const GAME_RUN_SUCCESS = "GAME_RUN_SUCCESS";
export const GAME_RUN_FAILURE = "GAME_RUN_FAILURE";
export const GAME_RESET = "GAME_RESET";

/**
 * FETCH
 */
export const FETCH_RESET = "FETCH_RESET";
/**
 * PROVIDERS
 */
export const PROVIDERS_FETCH = "PROVIDERS_FETCH";
export const PROVIDERS_FETCH_SUCCESS = "PROVIDERS_FETCH_SUCCESS";
export const PROVIDERS_FETCH_FAILURE = "PROVIDERS_FETCH_FAILURE";

export const PROVIDER_SELECT = "PROVIDER_SELECT";

/**
 * BRANDS
 */
export const BRANDS_FETCH = "BRANDS_FETCH";
export const BRANDS_FETCH_SUCCESS = "BRANDS_FETCH_SUCCESS";
export const BRANDS_FETCH_FAILURE = "BRANDS_FETCH_FAILURE";
export const BRAND_SELECT = "BRAND_SELECT";

/**
 * TAGS
 */
export const TAGS_FETCH = "TAGS_FETCH";
export const TAGS_FETCH_SUCCESS = "TAGS_FETCH_SUCCESS";
export const TAGS_FETCH_FAILURE = "TAGS_FETCH_FAILURE";
export const TAG_SELECT = "TAG_SELECT";
export const TAG_FAVORITE_SELECT = "TAG_FAVORITE_SELECT";

/**
 * SEARCH QUERY
 */
export const SEARCH_QUERY_SET = "SEARCH_QUERY_SET";
export const SEARCH_QUERY_CLEAR = "SEARCH_QUERY_CLEAR";

/**
 * JACKPOTS
 */
export const JACKPOT_ID = "jp-ex";

/**
 * WEB SOCKET
 */
export const JP_GET_STREAM_ID = "JP_GET_STREAM_ID";
export const JP_GET_STREAM_ID_SUCCESS = "JP_GET_STREAM_ID_SUCCESS";
export const JP_GET_STREAM_ID_FAILURE = "JP_GET_STREAM_ID_FAILURE";

export const JP_CONNECT = "JP_CONNECT";
export const JP_SET_WINS = "JP_SET_WINS";
export const JP_SET_SLOTS = "JP_SET_SLOTS";
export const JP_GET_CURRENCY = "JP_GET_CURRENCY";

export const JP_UPDATE_WINS = "JP_UPDATE_WINS";
export const JP_UPDATE_SLOTS = "JP_UPDATE_SLOTS";
export const JP_UPDATE_COOLDOWNS = "JP_UPDATE_COOLDOWNS";

export const JP_ACCEPT_WIN = "JP_ACCEPT_WIN";
export const JP_MARK_WIN_AS_VIEWED = "JP_MARK_WIN_AS_VIEWED";

export const JP_CATCH_ERROR = "JP_CATCH_ERROR";

/**
 * BONUSES
 */
export const BONUS_FETCH_REQUEST = "BONUS_FETCH_REQUEST";
export const BONUS_FETCH_SUCCESS = "BONUS_FETCH_SUCCESS";
export const BONUS_FETCH_FAILURE = "BONUS_FETCH_FAILURE";

export const BONUS_TAKE_REQUEST = "BONUS_TAKE_REQUEST";

export const SHOW_BONUS_MODAL = "SHOW_BONUS_MODAL";
export const HIDE_BONUS_MODAL = "HIDE_BONUS_MODAL";

export const SHOW_BONUS_ERROR = "SHOW_BONUS_ERROR";

/**
 * UI
 */
export const CHANGE_VISIBLE_BALANCE = "CHANGE_VISIBLE_BALANCE";
export const CHANGE_VISIBLE_MOB_NAV = "CHANGE_VISIBLE_MOB_NAV";
export const CHANGE_VISIBLE_NAV = "CHANGE_VISIBLE_NAVIGATION";
export const CHANGE_POSITION_MENU = "CHANGE_POSITION_MENU";
export const CHANGE_JACKPOTS_VISIBLE = "CHANGE_JACKPOTS_VISIBLE";
export const CHANGE_VISIBLE_SWEEPSTAKES_MOB_NAV =
  "CHANGE_VISIBLE_SWEEPSTAKES_MOB_NAV";
